// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Lora_d3ff00', '__Lora_Fallback_d3ff00'","fontWeight":500,"fontStyle":"italic"},"className":"__className_d3ff00"};